import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";
import { Link } from "@mui/material";

const AviatorsLink = () => (
  <Link
    target="_blank"
    sx={{
      fontWeight: 500,
      color: "primary.main",
      textDecoration: "none",
    }}
    href="https://am.ticketmaster.com/aviatorslv/"
  >
    Account Manager
  </Link>
);

export const purchaseSeatsLanguages = {
  similarSeatModalPrimaryButton: "Apply selection for all games",
  similarSeatModalSecondaryButton: "I want to choose seats",
  similarSeatModalBody: (seatTitle: string) => {
    return (
      <>
        Do you want to apply <b>{seatTitle.replace(/<br \/>/g, "")}</b> for all
        games in your pack?
      </>
    );
  },
};

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Pick Your Pack",
    description: "Pick the pack that you wish to attend all games for.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to Account Manager",
    description: (
      <>
        Click continue and connect your <AviatorsLink /> Manager using our
        secure login.
      </>
    ),
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Games",
    description: "Select the seats you wish to purchase for each game.",
  },

  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your <AviatorsLink /> within 24 hours of
        redemption. Reach out to Live Fan Support for any questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the Aviators Flex Pack work?",
    description: (
      <>
        The Aviators Flex Pack allows fans to easily select all the games for
        theme nights this season! Currently we have 3 different packs available
        to choose from. Simply log into your <AviatorsLink /> Manager and select
        your pack.
      </>
    ),
  },
  {
    title: "Do I have to select all my games now?",
    description:
      "When you select the pack you wish to purchase, all games in that pack will be added to your cart.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all current available inventory.",
  },
  {
    title: "Where are event tickets delivered?",
    description: (
      <>
        Tickets are delivered directly within your Aviators <AviatorsLink />.
      </>
    ),
  },
];
